import { onMounted, onUnmounted, ref } from 'vue';
import { debounce } from 'lodash-es';

interface IWindowSize {
  width: number;
  height: number;
}

export const useWindowSize = () => {
  const windowSize = ref<IWindowSize>({
    width: 0,
    height: 0
  });

  const updateSize = debounce(() => {
    windowSize.value = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }, 300);

  onMounted(() => {
    updateSize();
    window.addEventListener('resize', updateSize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateSize);
  });

  return windowSize;
};
